<template>
  <div>
    <v-img
      :aspect-ratio="16 / 9"
      height="450"
      :src="require('@/assets/images/news/dji_0596_v3.jpg')"
    ></v-img>

    <v-container class="text-justify">
      <h1 class="mb-4">{{ $t("communitySafetyNews.title") }}</h1>
      <h2 class="mt-5 mb-2">
        {{ $t("communitySafetyNews.subtitle_boaters") }}
      </h2>
      <h3 class="mt-4 mb-2">
        {{ $t("communitySafetyNews.intro_boaters") }}
      </h3>
      <div
        v-html="$t('communitySafetyNews.list_boaters')"
        class="mb-4 pl-4"
      ></div>
      <h3 class="mt-4 mb-2">
        {{ $t("communitySafetyNews.subtitle_on_boat") }}
      </h3>
      <div
        v-html="$t('communitySafetyNews.list_on_boat')"
        class="mb-4 pl-4"
      ></div>

      <h2 class="mt-5 mb-2">{{ $t("communitySafetyNews.subtitle_other") }}</h2>
      <div
        v-html="$t('communitySafetyNews.list_other')"
        class="mb-4 pl-4"
      ></div>

      <h2 class="mt-5 mb-2">
        {{ $t("communitySafetyNews.subtitle_swimmers") }}
      </h2>
      <div
        v-html="$t('communitySafetyNews.list_swimmers')"
        class="mb-4 pl-4"
      ></div>

      <v-row class="mt-5 justify-center">
        <v-col cols="12" md="10">
          <v-img
            :src="require('@/assets/images/news/dji_0596_v3.jpg')"
            height="400"
            contain
            class="grey lighten-2 rounded elevation-2"
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CommunitySafetyNews",
};
</script>
